<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 20px;">Back</button>


  </div>
  <div fxFlex="50" class="text-right">


  </div>
</div>


<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="50">


    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Transaction</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoading || walletTransaction">
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsTransaction ">
              <label fxFlex="35" class="secondary">{{ field.header }}</label>
              <label fxFlex="65" *ngIf="walletTransaction">{{ field.cell(walletTransaction) }}</label>
            </div>
          </ng-container>

        </mat-card-content>

      </mat-card>

      <mat-card class="content-card" *ngIf="walletTransaction && walletTransaction.linkedLoad">
        <mat-card-header>
          <mat-card-title>
            <h5>Partner Load</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoading || walletTransaction?.linkedLoad">
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsLoad ">
              <label fxFlex="35" class="secondary">{{ field.header }}</label>
              <label fxFlex="65" *ngIf="walletTransaction">{{ field.cell(walletTransaction.linkedLoad) }}</label>
            </div>
          </ng-container>

          <div style="margin: 15px;" *ngIf="!isWallet()">

            <h4>Documents</h4>
            <ng-container *ngIf="walletTransaction.linkedLoad.documents && walletTransaction.linkedLoad.documents.length > 0; else noDocuments">
              <div *ngFor="let doc of walletTransaction.linkedLoad.documents">

                <div fxLayout="row" fxLayoutGap="10px">
                  <div fxFlex="5"><mat-icon>attachment</mat-icon></div>
                  <div fxFlex (click)="downloadDocument(doc.id)" style="cursor:pointer;"><small>{{ doc.name }}</small></div>
                  <div fxFlex="10" class="text-right"><mat-icon style="cursor:pointer; color: red;" (click)="deleteDocument(doc.id)">clear</mat-icon></div>
                </div>


              </div>
            </ng-container>
            <ng-template #noDocuments>
              <i>(no documents)</i>
            </ng-template>
            <div class="text-right" style="margin-top: 15px;">
              <button data-tooltip="Upload document" mat-flat-button (click)="uploadDocuments(walletTransaction.linkedLoad.id)" [disabled]="isBusy">
                <mat-icon>file_upload</mat-icon> Upload a document
              </button>
            </div>
          </div>


        </mat-card-content>

      </mat-card>


    </div>


  </div>

  <div fxFlex="50">


  </div>

</div>
